export const GET_LOYALTY_REQUEST = 'GET_LOYALTY_REQUEST';
export const GET_LOYALTY_SUCCESS = 'GET_LOYALTY_SUCCESS';
export const GET_LOYALTY_FAILURE = 'GET_LOYALTY_FAILURE';

export const CREATE_GIVEX_LOYALTY_REQUEST = 'CREATE_GIVEX_LOYALTY_REQUEST';
export const CREATE_GIVEX_LOYALTY_SUCCESS = 'CREATE_GIVEX_LOYALTY_SUCCESS';
export const CREATE_GIVEX_LOYALTY_FAILURE = 'CREATE_GIVEX_LOYALTY_FAILURE';
export const UPDATE_LOYALTY_REGISTRATION_MODAL_STATUS =
  'UPDATE_LOYALTY_REGISTRATION_MODAL_STATUS';
export const DISPLAY_TRANSFER_BALANCE_MODAL = 'DISPLAY_TRANSFER_BALANCE_MODAL';
